import { useCreateAdminMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import { adminSchema } from "../configs";
import AdminForm from "../forms/Admin.form";

const CreateAdmin: React.FC = () => {
  const [createAdmin, { isLoading }] = useCreateAdminMutation();

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phone: "",
  };

  return (
    <div className="p-4 w-full">
      <AdminForm
        initialValues={initialValues}
        validationSchema={adminSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await createAdmin(values);
          if (!result.error) {
            showToast("Admin créé avec succès", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default CreateAdmin;
